/**
 * API Client - Re-export da nova arquitetura modular
 * 
 * Este arquivo mantém backward compatibility.
 * A implementação real está em lib/api/
 */

import apiClient, {
  httpClient,
  authService,
  profileService,
  attachmentService,
  productService,
  meetingService,
} from './api/index'

export default apiClient

export {
  httpClient,
  authService,
  profileService,
  attachmentService,
  productService,
  meetingService,
}